import { render, staticRenderFns } from "./ModalNewVenhicleService.vue?vue&type=template&id=f0d5d588&"
import script from "./ModalNewVenhicleService.vue?vue&type=script&lang=js&"
export * from "./ModalNewVenhicleService.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports